<template>
	<div id="mypage">
		<div id="content">
			<!-- メニューコンポーネント -->
			<MyMenu/>
			<!-- コンテンツ内部 -->
			<div class="content-blk"><div class="inner"><router-view></router-view></div></div>
		</div>
	</div>
</template>

<script>
import MyMenu from './MypageMenu.vue'

export default {
	components: {
		MyMenu,
	},
	setup() {
		
	},
}
</script>

<style scoped>
@media screen and (max-width:425px) {
	#mypage #content {
		padding-top: 55px;
		padding-bottom: 40px;
	}	
}
</style>